import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import find from 'lodash/find';

import { i18n } from '@/core/i18n';

@Component({
    data() {
        return {
            language: ''
        };
    }
})
export default class Language extends mixins(i18n.Mixins.Culture) {
    language;

    @Prop(Array)
    languages;

    @Prop(Boolean)
    hideName: boolean;

    mounted() {
        this.language = this.getLang();
    }

    get languageName() {
        const culture = find(this.languages, { value: this.language });

        return culture?.text || this.language;
    }

    async change(lang: string) {
        await this.setLang(lang);

        this.language = this.getLang();
    }
}
